import { useMemo } from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { makeSelectContact } from 'flow/selectors/contact-selectors';
import {
    selectVisitorContact,
    selectVisitorContactKey,
} from 'flow/selectors/TicketsSelectors';
import { TicketKey } from 'flow/types/EntityKeys';
import { isThirdPartyContactKey } from 'flow/utils';

const useTicketVisitorContact = (ticketKey: TicketKey) => {
    const visitorContact = useAppSelector((state) =>
        selectVisitorContact(state, ticketKey),
    );
    const visitorContactKey = useAppSelector((state) =>
        selectVisitorContactKey(state, ticketKey),
    );

    const selectContact = useMemo(makeSelectContact, []);
    const storeContact = useAppSelector((state) =>
        visitorContactKey ? selectContact(state, visitorContactKey) : undefined,
    );

    const contact = storeContact || visitorContact;
    const contactKey = contact?.get('key');
    const contactIsSaved = !!contactKey && !isThirdPartyContactKey(contactKey);

    return { contact, contactIsSaved };
};

export default useTicketVisitorContact;
